/**
 * Password encoding utility
 * Encodes password using Base64 encoding before sending to backend
 * Backend should decode using the same method
 */

/**
 * Encode password using Base64
 * @param {string} password - Plain text password
 * @returns {string} Encoded password
 */
export const encodePassword = (password) => {
  if (!password) return password;

  try {
    // Encode to Base64
    const encoded = btoa(unescape(encodeURIComponent(password)));
    return encoded;
  } catch (error) {
    console.error("Error encoding password:", error);
    return password; // Return original if encoding fails
  }
};

/**
 * Decode password from Base64 (for testing purposes)
 * @param {string} encodedPassword - Encoded password
 * @returns {string} Decoded password
 */
export const decodePassword = (encodedPassword) => {
  if (!encodedPassword) return encodedPassword;

  try {
    // Decode from Base64
    const decoded = decodeURIComponent(escape(atob(encodedPassword)));
    return decoded;
  } catch (error) {
    console.error("Error decoding password:", error);
    return encodedPassword; // Return original if decoding fails
  }
};
